import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, RouterLink } from '@angular/router';
import { PageLayoutComponent } from '../../../components/shared/page-layout/page-layout.component';

@Component({
  selector: 'app-mentions-legales',
  standalone: true,
  imports: [CommonModule, PageLayoutComponent, RouterLink],
  templateUrl: './mentions-legales.component.html',
  styleUrl: './mentions-legales.component.scss'
})
export class MentionsLegalesComponent implements OnInit {
  title = 'Mentions Légales';
  subtitle = 'Informations légales et réglementaires sur Brokins et ses activités de courtage en assurance';
  heroImage = 'assets/static_pages_images/01_La_creation_d_Adam.jpg';
  breadcrumbs = [
    { label: 'Legal', url: undefined },
    { label: 'Mentions Légales', url: undefined }
  ];
  prevPage = {
    title: 'Notre Équipe',
    link: '/notre-equipe'
  };
  nextPage = {
    title: 'Politique de Confidentialité',
    link: '/politique-confidentialite'
  };

  constructor(private router: Router) {}

  ngOnInit(): void {}

  navigateToContact(): void {
    this.router.navigate(['/contact']);
  }
}
